import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";


// import JS files
import useFetch from "../../context/useFetch";
import MuiButton from "../shares/MuiButton";
import MuiTextField from "../shares/MuiTextField";

const ForgotPassword = (props) => {
  const navigate = useNavigate();

  const [phone, setPhone] = useState(undefined);
 
  const createOtpRequest = useFetch({
    method: "post",
    url: "user/check_user",
    data: { phone: phone },
    noHeader: true,
    trigger: false,
    argFunc: (res) => {
      if (res.data == "code_sent")
        navigate("/forgot-password-otp", {
          state: {
            phone: phone,
          },
        });
    },
    errMessage: (mess) => {},
  });

  return (
    <>
      <div className="min-h-screen bg-gray-100 py-6 flex flex-col justify-center sm:py-12">
        <div className="mx-auto	 w-10/12 sm:w-auto relative py-3 sm:max-w-xl sm:mx-auto">
          <div className="absolute inset-0 bg-gradient-to-r from-myblue-100 to-myblue-100 shadow-lg transform -skew-y-6 sm:skew-y-0 -rotate-6 rounded-3xl"></div>
          <div className="mx-auto relative px-4 py-10 bg-white shadow-lg rounded-3xl sm:p-20">
            <div className="max-w-md mx-auto">
              <div className="mb-6 back-icon">
                <ArrowForwardIcon onClick={() => navigate(-1)} />
              </div>

              <div className="flex justify-center">
                <h1 className="text-base md:text-2xl font-semibold">
                  تغییر رمز عبور حساب
                </h1>
              </div>
              <div className="mt-3">
                <span className="text-xs sm:text-base">
                  برای تغییر رمز عبور، شماره همراه خود را وارد کنید.
                </span>
              </div>
              <div className="divide-y divide-gray-200">
                <div className="text-base leading-6 space-y-4 text-gray-700 sm:text-lg sm:leading-7">
                  <div className="mt-4">
                    <MuiTextField
                      id="mobile_number"
                      label="شماره‌همراه"
                      variant="outlined"
                      size="small"
                      isLTR={true}
                      type="number"
                      onChange={(e) => setPhone(e.target.value)}
                      value={phone !== null ? phone : ""}
                    />
                  </div>
                  <div>
                    <MuiButton
                      onClick={() => createOtpRequest.reFetch()}
                      variant="contained"
                      color="primary"
                      text="تایید"
                      htmlType="submit"
                      disabled={phone == undefined}
                      isFullWidth={true}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ForgotPassword;
